import { StatusBar } from "expo-status-bar";
import { useContext, useEffect } from "react";
import {
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import Icon from "react-native-vector-icons/Ionicons";
import { GlobalContext } from "../contexts/global";
import { AuthContext } from "../contexts/auth";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import BetterAlert from "./BetterAlert";
import Loading from "./Loading";
import { IS_WEB } from "@services/Config";

export default function PageTitle({
  title,
  children,
  navigation,
  onClickDimmisKeyboard = false,
  secondaryButtons = [],
}) {
  const { loading, showAlert, setLoading } = useContext(GlobalContext);
  const { loginType, setIsSignUp } = useContext(AuthContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading({ timeout: true, ...loading });
    }, 30000);
    return () => clearTimeout(timer);
  }, []);

  if (loading.show && !loading.timeout) {
    return <Loading message={loading.message} />;
  }

  return (
    <SafeAreaView style={styles.viewPrincipal}>
      <StatusBar animated={true} />
      <View style={styles.titleBar}>
        {navigation ? (
          <Icon
            name={"arrow-back"}
            size={32}
            color={Colors.WHITE}
            style={styles.iconBack}
            onPress={() => {
              if(loginType && loginType === "autologin" && IS_WEB){
                window.location.reload();
              }else{
                navigation.goBack();
              }
            }}
          />
        ) : null}
        <Text style={styles.titleText}>{title.toUpperCase()}</Text>
        {secondaryButtons.length > 0 ? (
          <View style={styles.secondaryButtonsView}>{secondaryButtons.map((button) => button)}</View>
        ) : null}
      </View>
      {onClickDimmisKeyboard ? (
        <KeyboardAvoidingView
          style={styles.viewSecundaria}
          behavior={Platform.OS === "ios" ? "padding" : "height"}
          enabled={true}
        >
          <TouchableWithoutFeedback onPress={!IS_WEB ? Keyboard.dismiss : null}>
            <View style={styles.viewSecundariaKeyboard}>{children}</View>
          </TouchableWithoutFeedback>
        </KeyboardAvoidingView>
      ) : (
        <View style={[styles.viewWithouKeyboard,
        !navigation ? {borderBottomLeftRadius: 0, borderBottomRightRadius: 0} : null]}>{children}</View>
      )}
      <BetterAlert {...showAlert} />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  viewPrincipal: {
    backgroundColor: Colors.PRIMARY,
    flex: 1,
    flexGrow: 1,
    paddingTop: 28,
    // paddingBottom: 18,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  viewSecundaria: {
    backgroundColor: Colors.WHITE,
    borderRadius: 8,
    width: "100%",
    flex: 1,
    flexGrow: 1,
    marginBottom: 8,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  viewSecundariaKeyboard: {
    flex: 1,
    flexGrow: 1,
    padding: 8,
  },
  viewWithouKeyboard: {
    backgroundColor: Colors.WHITE,
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
    width: "100%",
    flex: 1,
    flexGrow: 1,
    padding: 8,
  },
  titleBar: {
    alignItems: "center",
    flexDirection: "row",
    padding: 16,
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
  },
  titleText: {
    color: Colors.WHITE,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
  },
  iconBack: {
    position: "absolute",
    left: 5,
  },
  secondaryButtonsView: {
    flexDirection: "row",
    alignSelf: "flex-end",
    position: "absolute",
    right: 5,
    padding: 8,
    alignItems: "center",
    justifyContent: "center"
  }
});
